<template>
    <v-dialog v-model="listSettingsModal" max-width="1000" persistent>
        <v-card>
            <v-card-title class="headline">{{ "Choose columns to show" | t }}</v-card-title>
            <v-card-subtitle class="subtitle-1 mb-0 pb-0">{{
                "Select which fields will be selected" | t
            }}</v-card-subtitle>
            <v-card-text>
                <v-row no-gutters>
                    <v-col v-for="row in listSettingsColumns" :key="row.text" md="4" sm="12">
                        <v-checkbox
                            hide-details
                            class="mt-0 mb-0"
                            @click.stop="toggleListSettingsColumn(row)"
                            :label="row.text | t"
                            :input-value="row.isSelected"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="bal-dark-gray" text @click="toggleListSettingsModal">
                    {{ "Close" | t }}
                </v-btn>

                <v-btn color="bal-green" text @click="handleReturnClick">
                    {{ "Save" | t }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar color="error" bottom :timeout="2500" :value="errorMsg">
            <div style="display: flex">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">{{ "You must choose more than zero columns." }}</div>
            </div>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
export default {
    name: "client-list-settings-modal",
    data() {
        return {
            errorMsg: false
        };
    },
    computed: {
        ...mapState("ClientStore", ["listSettingsModal", "listSettingsColumns", "clientTableHeaders"])
    },
    mounted() {
        document.addEventListener("keydown", this.handleEscClick);
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleEscClick);
    },
    methods: {
        ...mapMutations("ClientStore", [
            "toggleListSettingsModal",
            "toggleListSettingsColumn",
            "setClientsTableHeaders"
        ]),
        ...mapActions("UserStore", ["saveUserClientSearchColumnSettings"]),
        async handleReturnClick() {
            let counter = 0;
            await this.listSettingsColumns.forEach(x => {
                if (x.isSelected === true) counter++;
            });
            if (counter > 0) {
                await this.setClientsTableHeaders();
                await this.toggleListSettingsModal();
                await this.saveUserClientSearchColumnSettings(this.clientTableHeaders);
            } else this.errorMsg = true;
        },
        handleEscClick(e) {
            if (e.keyCode === 27 && this.listSettingsModal) {
                e.preventDefault();
                this.toggleListSettingsModal();
            }
        }
    }
};
</script>

<style scoped></style>
